export default __webpack_public_path__ + "static/bg-b15f0928f16d60e0bf04cd4763841465.webp";